module.exports = __webpack_public_path__ + "static/media/icon-spaceship.2a36ca49.svg";